import { HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { User } from '@core/user/user.types';
import { FuseMockApiService } from '@fuse/lib/mock-api/mock-api.service';
import { user as userData } from '@mock-api/common/user/data';
import { assign, cloneDeep } from 'lodash-es';

@Injectable({
    providedIn: 'root'
})
export class UserMockApi
{
    private _fuseMockApiService = inject(FuseMockApiService);

    private _user: User = userData;

    /**
     * Constructor
     */
    constructor()
    {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void
    {
        // -----------------------------------------------------------------------------------------------------
        // @ User - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/common/user')
            .reply(() => [200, cloneDeep(this._user)]);

        // -----------------------------------------------------------------------------------------------------
        // @ User - PATCH
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onPatch('api/common/user')
            .reply(({request}) => {

                // Get the user mock-api
                const user = cloneDeep((request as HttpRequest<{ user: User }>).body.user);

                // Update the user mock-api
                this._user = assign({}, this._user, user);

                // Return the response
                return [200, cloneDeep(this._user)];
            });
    }
}
